var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFetch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06144 20.9392C9.43704 21.3148 9.43704 21.9232 9.06144 22.2988L7.02173 24.3385C6.64613 24.7141 6.03768 24.7141 5.66207 24.3385C5.28646 23.9629 5.28648 23.3545 5.66207 22.9789L7.70179 20.9392C8.07739 20.5636 8.68611 20.5636 9.06144 20.9392Z",
    fill: "#F7FAFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3388 6.66064C23.7144 7.03624 23.7144 7.64468 23.3388 8.02029L21.2991 10.06C20.9235 10.4356 20.315 10.4356 19.9394 10.06C19.5638 9.68442 19.5638 9.07597 19.9394 8.70036L21.9791 6.66064C22.3542 6.28532 22.9632 6.28532 23.3388 6.66064Z",
    fill: "#F7FAFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80758 15.4997C6.80758 16.0309 6.37726 16.4612 5.84606 16.4612H2.96152C2.43032 16.4612 2 16.0309 2 15.4997C2 14.9685 2.43032 14.5382 2.96152 14.5382H5.84606C6.37726 14.5382 6.80758 14.9685 6.80758 15.4997Z",
    fill: "#F7FAFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15.4997C27 16.0309 26.5696 16.4612 26.0384 16.4612H23.1539C22.6227 16.4612 22.1924 16.0309 22.1924 15.4997C22.1924 14.9685 22.6227 14.5382 23.1539 14.5382H26.0384C26.5696 14.5382 27 14.9685 27 15.4997Z",
    fill: "#F7FAFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06144 10.0602C8.68584 10.4358 8.0774 10.4358 7.70179 10.0602L5.66207 8.0205C5.28647 7.64491 5.28647 7.03646 5.66207 6.66085C6.03766 6.28524 6.64611 6.28526 7.02172 6.66085L9.06144 8.70057C9.43703 9.07617 9.43703 9.68489 9.06144 10.0602Z",
    fill: "#F7FAFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3388 24.3388C22.9632 24.7144 22.3547 24.7144 21.9791 24.3388L19.9394 22.2991C19.5638 21.9235 19.5638 21.315 19.9394 20.9394C20.315 20.5638 20.9235 20.5638 21.2991 20.9394L23.3388 22.9791C23.7141 23.3542 23.7141 23.9632 23.3388 24.3388Z",
    fill: "#F7FAFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4996 7.80758C13.9684 7.80758 13.5381 7.37726 13.5381 6.84606V3.96152C13.5381 3.43032 13.9684 3 14.4996 3C15.0308 3 15.4611 3.43032 15.4611 3.96152V6.84606C15.4611 7.37726 15.0308 7.80758 14.4996 7.80758Z",
    fill: "#F7FAFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4996 27.9995C13.9684 27.9995 13.5381 27.5692 13.5381 27.038V24.1534C13.5381 23.6222 13.9684 23.1919 14.4996 23.1919C15.0308 23.1919 15.4611 23.6222 15.4611 24.1534V27.038C15.4611 27.5692 15.0308 27.9995 14.4996 27.9995Z",
    fill: "#F7FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFetch);
export default __webpack_public_path__ + "static/media/Fetch.bdb90aae3f943fe46ca82313cd96c17d.svg";
export { ForwardRef as ReactComponent };